import { Component, Injector, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { AuditBase, Logger } from '../../../common/public-api';

/**
 * Component base class
 *
 * @export
 * @abstract
 * @class ComponentBaseComponent
 * @extends {AuditBase}
 * @implements {OnDestroy}
 */
@Component({
  template: '',
})
export abstract class ComponentBaseComponent
  extends AuditBase
  implements OnDestroy
{
  protected _logger: Logger;
  protected _translateService: TranslateService;
  protected _destroy$ = new Subject<void>();

  constructor(injector: Injector) {
    super();
    this._logger = injector.get(Logger);
    this._translateService = injector.get(TranslateService);
    this._logger.trace(`${new.target.name}(${this.objectId}) - constructor`);
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
